import React, { useEffect, useRef } from 'react';
import { motion, useAnimation } from 'framer-motion';

const Card: React.FC<{ title: string; description: string; delay: number }> = ({ title, description, delay }) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const controls = useAnimation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          controls.start('visible');
        } else {
          controls.start('hidden');
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    );

    const currentRef = cardRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [controls]);

  const descriptionLines = description.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line} <br />
    </React.Fragment>
  ));

  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, x: -50 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.5, delay } },
      }}
      initial="hidden"
      animate={controls}
      ref={cardRef}
      className="motion-wrapper"
    >
      <div className="w-full h-[320px] bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg transition-shadow duration-500 flex flex-col justify-start p-6 overflow-hidden">
        <h3 className="text-xl text-center mb-4" style={{ color: '#003942', fontFamily: "'Cormorant', serif", fontWeight: 700 }}>{title}</h3>
        <div className="w-8 h-0.5 mx-auto mb-4" style={{ backgroundColor: '#45B8A9' }} />
        <div className="text-sm text-gray-600 overflow-auto" style={{ fontFamily: "'Outfit', sans-serif" }}>
          {descriptionLines}
        </div>
      </div>
    </motion.div>
  );
};

export default Card;
